import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const TL2424Icon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "TL2424IconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 3H1V4V19V20H2H22H23V19V4V3H22H2Z"
          fill="#E31D1C"
          stroke="#F7FCFF"
          strokeWidth="2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4L17 11.5L2 19V4Z"
          fill="#FECA00"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 4L12 11.5L2 19V4Z"
          fill="#272727"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.15477 13.0053L4.89257 14.3178L4.76071 12.4519L3.15105 11.4603L4.82972 10.9336L5.10425 9.08474L6.26642 10.5486L7.96144 10.0945L7.08535 11.829L7.9373 13.502L6.15477 13.0053Z"
          fill="#F7FCFF"
        />
      </svg>
    </svg>
  );
};

export default TL2424Icon;
